import { Box } from '@mui/material'
import {
  IconBrandInstagram,
  IconBrandFacebook,
  IconBrandSnapchat,
  IconBrandGoogle,
  IconBrandReddit,
  IconBrandTwitter,
  IconBrandCampaignmonitor,
  IconBrandLinkedin,
  IconBrandX,
  IconBrandYoutube,
} from '@tabler/icons-react'
import { Channel } from '../../../types/task'

const PLATFORM_ICON = {
  meta: IconBrandInstagram,
  facebook: IconBrandFacebook,
  instagram: IconBrandInstagram,
  tiktok: () => <img src={'/socials/tiktok.svg'} alt="Social icon" width="16px" height="16px" />,
  snapchat: IconBrandSnapchat,
  googleDisplay: IconBrandGoogle,
  google: IconBrandGoogle,
  youtube: IconBrandYoutube,
  spotify: () => <img src={'/socials/spotify.svg'} alt="Social icon" width="16px" height="16px" />,
  reddit: IconBrandReddit,
  twitter: IconBrandTwitter,
  x: IconBrandX,
  campaign: IconBrandCampaignmonitor,
  fb: () => <img src={'/socials/fb.svg'} alt="Social icon" width="16px" height="16px" />,
  ig: () => <img src={'/socials/ig.svg'} alt="Social icon" width="16px" height="16px" />,
  internalRecruspin: () => (
    <img src={'/socials/recruspin.svg'} alt="Social icon" width="16px" height="16px" />
  ),
  linkedin: IconBrandLinkedin,
}

export interface Props {
  platform?: keyof typeof PLATFORM_ICON | Channel
}

const PlatformIcon: React.FC<Props> = ({ platform }) => {
  const Icon = platform ? PLATFORM_ICON[platform] : null

  if (!Icon) return null

  return (
    <Box
      width="24px"
      height="24px"
      display="inline-flex"
      justifyContent="center"
      alignItems="center"
    >
      {typeof Icon === 'function' && !('$$typeof' in Icon) ? <Icon /> : <Icon size="16px" />}
    </Box>
  )
}

export default PlatformIcon
